import { Button as OriginButton } from '@material-ui/core';
import React from 'react';
import { loginChecker } from '../../utils/login-controler';
import { useHistory } from 'react-router';

/**
 * click時にアクセス権限のチェックを行う
 * @param props
 */
export const Button: React.FC<any> = (props: any) => {
  const history = useHistory();

  const { onClick, ...otherProps } = props;
  const onClickWithAuthCheck = (e: any) => {
    if (loginChecker(history)) {
      return;
    }

    onClick(e);
  };

  return <OriginButton {...otherProps} onClick={onClickWithAuthCheck} />;
};

export default Button;
